import { render, staticRenderFns } from "./MoleculeButtonIcon.vue?vue&type=template&id=10c1bf8d&scoped=true"
import script from "./MoleculeButtonIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeButtonIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c1bf8d",
  null
  
)

export default component.exports